/* eslint-disable import/no-duplicates */
import { format, isToday, isValid, parse } from "date-fns";
import { enGB } from "date-fns/locale";

import { AppointmentSlot } from "@customTypes/appointment";

// todo: Rename this file to "dateHelpers.ts" or "dateUtils.ts"
export const parseDate = (dateString: string) => {
  if (dateString?.length && dateString?.endsWith("Z")) {
    return new Date(dateString);
  } else if (dateString?.length && dateString?.includes("/")) {
    const parsedDate = parse(dateString, "dd/MM/yyyy", new Date());
    // console.log(parsedDate);
    return parsedDate;
  } else if (dateString?.length && dateString?.includes("-")) {
    const parsedDate = parse(dateString, "yyyy-MM-dd", new Date());
    // console.log(parsedDate);
    return parsedDate;
  }
  return null;
  // throw new Error("[From parseDate]: Invalid dateString to be parsed");
};

export const isValidDate = (inputDate: string) => {
  const parsedDate = parseDate(inputDate);

  return isValid(parsedDate);
};

export const formatDateToString = (
  date: Date,
  includeTime?: boolean,
  locale?: string
) => {
  return format(
    date,
    `dd/MM/yyyy${includeTime ? "," : ""} ${
      includeTime ? (locale?.includes("fr") ? "HH:mm" : "hh:mm a") : ""
    }`,
    {
      locale: enGB,
    }
  );
};

export const combineDateWithCurrentTime = (originalDate: Date): Date => {
  // Get date components from the original date
  const year = originalDate.getFullYear();
  const month = originalDate.getMonth();
  const day = originalDate.getDate();

  // Get current time components
  const now = new Date();
  const hours = now.getHours();
  const minutes = now.getMinutes();
  const seconds = now.getSeconds();
  const milliseconds = now.getMilliseconds();

  // Create a new Date object with the same date and current time
  const combinedDate = new Date(
    year,
    month,
    day,
    hours,
    minutes,
    seconds,
    milliseconds
  );

  return combinedDate;
};

//* Dayjs can also do this with a plugin, but the extra import may not be worth it
export const getLastQuarter = () => {
  const month = new Date().getMonth();
  if (month >= 0 && month <= 2) {
    return "q4";
  } else if (month >= 3 && month <= 5) {
    return "q1";
  } else if (month >= 6 && month <= 8) {
    return "q2";
  } else {
    return "q3";
  }
};

export const getIsTimeSlotDisabled = (
  slots: AppointmentSlot[] | null | undefined,
  date: Date | null,
  hour: number
): boolean => {
  // Early return if no data yet
  if (!date || !slots) return false;

  // Create clean date for comparison
  const selectedDate = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    0,
    0,
    0,
    0
  );

  // Disable time slot if it's today but past the hour
  if (isToday(selectedDate) && new Date().getHours() >= hour) return true;

  // Find slots for the same day
  const sameDaySlots = slots.filter(slot => {
    const slotDateOnly = new Date(
      slot.startTime.getFullYear(),
      slot.startTime.getMonth(),
      slot.startTime.getDate(),
      0,
      0,
      0,
      0
    );
    return slotDateOnly.getTime() === selectedDate.getTime();
  });

  if (sameDaySlots.length) {
    return sameDaySlots.some(slot => slot.startTime.getHours() === hour);
  }

  return false;
};
